import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Interactable from '../../Component/Interactable';
import Point from '../../Utility/Point';
import AnimationComponent from '../../Component/Animation';
import SpeechBubble from './SpeechBubble';
import Game from '../../Game';
import FoxComponent from '../../Component/World/Fox';

export enum FoxState {
    SEARCHING = 'searching',
    FOUND = 'found',
}

export default class Fox extends GameObject {
    protected onCreate(params: { x: number; y: number }): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable);
        this.addComponent<FoxComponent>(FoxComponent, params);
        this.addComponent<Interactable>(Interactable, {
            enabled: false,
            buttonMode: true,
        });

        // Add the shadow sprite.
        const shadowSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'fox',
            anchor: new Point(0.5, 1),
            tint: 0,
            alpha: 0.2,
        });
        const shadowTransform: TransformComponent = shadowSprite.getComponent(
            TransformComponent
        );
        shadowTransform.position.set(15, -4);
        shadowTransform.scale.set(0.7, 0.25);

        shadowSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'FoxShadowIdle',
        });
        this.addChild(shadowSprite);

        // Add the sprite base.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'fox',
            anchor: new Point(0.5, 1),
        });

        baseSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'FoxIdle',
        });
        this.addChild(baseSprite);

        // Add the speech bubble.
        const speechBubble: SpeechBubble = GameObject.Instantiate(
            SpeechBubble,
            {
                x: -20,
                y: -200,
                text: '',
                textStyle: Game.style.getStyle('fox.text'),
                visible: false,
            }
        );
        this.addChild(speechBubble);
    }
}
